var UIDropdownDrawer = (function ($) {
    UIDropdownDrawer = function () {
        var that = this;

        // DOM

        // CONST
        that.class = {
            desktop: "js-dd-drawer-desktop",
            tablet: "js-dd-drawer-tablet",
            mobile: "js-dd-drawer-mobile",
        };

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UIDropdownDrawer.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UIDropdownDrawer.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on("click", ".js-dd-button-drawer", function (e) {
            var $button = $(this),
                $wrapper = $button.parents(".dd-wrapper"),
                wrapper_desktop = $wrapper.hasClass(that.class.desktop),
                wrapper_tablet = $wrapper.hasClass(that.class.tablet),
                wrapper_mobile = $wrapper.hasClass(that.class.mobile);

            if (
                (wrapper_desktop && $.sa.is_desktop()) ||
                (wrapper_tablet && $.sa.is_tablet()) ||
                (wrapper_mobile && $.sa.is_mobile()) ||
                (!wrapper_desktop && !wrapper_tablet && !wrapper_mobile)
            ) {
                that.show($wrapper);
            }

        });
    };

    UIDropdownDrawer.prototype.show = function ($wrapper) {
        var that = this;

        // Prevent blinking dropdown if try to open nested dropdown second and more times
        if (!$wrapper.parents(".dd-wrapper").length) {
            that.hideAll();
        }

        setTimeout(function () {
            var $drawer_header = $wrapper.children(".dd-header").html();
            var $drawer_content = $wrapper.children(".dd").clone();

            $.uiDrawerBottom({
                header_contrast: true,
                header: $drawer_header || undefined,
                content: $drawer_content,
                onBgClick: function (uiDrawerBottom) {
                    uiDrawerBottom.close();
                },
            });
        }, 0);
    };

    UIDropdownDrawer.prototype.hideAll = function () {
        var that = this;

        $.sa.$document.find(".dd-wrapper").each(function () {
            var $wrapper = $(this);

            $wrapper.find(".dd").removeClass(that.class.is_active);
            $wrapper.find(".js-dd-button").removeClass(that.class.is_active);
        });
    };

    return UIDropdownDrawer;
})($);
